import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, {
    LOAD_NOTIFICATIONS,
    LOAD_NOTIFICATIONS_COUNTERS,
} from '../actions';

export const loadNotificationsEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_NOTIFICATIONS).mergeMap(() =>
        Observable.from(api.fetchNotifications())
            .map(response => actions.loadNotificationsSuccess(response.data))
            .catch(error =>
                Observable.of(actions.loadNotificationsFailure(error)),
            ),
    );

export const loadNotificationsCountersEpic = (action$, store, { api }) =>
    action$
        .ofType(LOAD_NOTIFICATIONS_COUNTERS)
        .mergeMap(({ payload }) =>
            Observable.from(api.fetchNotificationsCounters(payload.query)).map(
                response => actions.loadNotificationsCountersSuccess(response.data),
            ),
        );
